import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-intro',
  templateUrl: './alumni-intro.component.html',
  styleUrls: ['./alumni-intro.component.scss']
})
export class AlumniIntroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
